import { render, staticRenderFns } from "./AdminTools.vue?vue&type=template&id=24267dd2"
import script from "./AdminTools.vue?vue&type=script&lang=js"
export * from "./AdminTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports